var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-alert',{staticClass:"m-auto"},[_vm._v(" You have been logged out of the system. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }